var _style, _rect, _path, _path2, _path3, _polyline, _polyline2, _path4, _path5, _path6, _polyline3, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 318.2",
    style: {
      enableBackground: "new 0 0 512 318.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_5_);}\n\t.st4{fill:url(#SVGID_6_);}\n\t.st5{fill:url(#SVGID_8_);}\n\t.st6{fill:url(#SVGID_9_);}\n\t.st7{fill:url(#SVGID_11_);}\n\t.st8{fill:url(#SVGID_12_);}\n\t.st9{fill:url(#SVGID_14_);}\n\t.st10{fill:url(#SVGID_15_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.4,
    className: "st0",
    width: 512,
    height: 318.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 101.1836,
    cy: 273.9763,
    r: 512.0785,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st1",
    d: "M263.5,142.8v-10.1c0,0-0.5-7.9-8.8-7.9h-12.9v18h-13.2v-52h32c0,0,16.7-2,16.7,15.2 c0,9-7.4,12.1-7.4,12.1s6.4,3,6.4,11.8v12.8L263.5,142.8 M241.8,112.6h13.6c4,0,7.2-2.2,7.2-4.9c0-2.7-3.3-4.9-7.2-4.9h-13.6 V112.6L241.8,112.6"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 101.2017,
    cy: 273.9758,
    r: 512.044,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    className: "st2",
    d: "M419.2,142.8L398.3,108v34.8h-11.4h-2.1h-12.4l-4.7-10.9h-24.1l-4.6,10.9h-12.1h-2.2h-6.3 c0,0-17.8-2.5-17.8-24.5c0-28.9,20.2-27.7,20.9-27.9l16.3,0.4v11.7l-13.4,0.2c0,0-8.7,0-9.8,11.4c-0.1,1.3-0.2,2.5-0.2,3.6 c0,17.6,15.3,12.1,15.8,12l16.4-38.8H365l19.8,47.2V90.8h18.7l20.7,34.2V90.8h13.3v52H419.2 M349.3,118.6h12.8l-6.3-15.5 L349.3,118.6L349.3,118.6"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 101.2026,
    cy: 273.9836,
    r: 512.0485,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    className: "st3",
    d: "M159.9,142.8v-35.9l-16.5,35.9h-10.8L116,107.1v35.7h-11.5h-1.8H89.9l-4.6-10.9H61.2 l-4.7,10.9H42.1l21.9-52h18.6l20.1,47.8V90.8h20.9l14.5,32.3l14.4-32.3h20.9v52H159.9 M66.8,118.6h12.8l-6.4-15.5L66.8,118.6 L66.8,118.6"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 101.1743,
    cy: 273.9836,
    r: 512.0867,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_10_",
    className: "st4",
    points: "180.6,142.8 180.6,90.8 221.8,90.8 221.8,103 193.9,103 193.9,111 221.1,111  221.1,122.8 193.9,122.8 193.9,131.6 221.8,131.6 221.8,142.8 180.6,142.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 101.1943,
    cy: 273.9861,
    r: 512.0569,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_13_",
    className: "st5",
    points: "282.9,143 282.9,90.8 296.1,90.8 296.1,143 282.9,143  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 101.1943,
    cy: 273.9836,
    r: 512.0429,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    className: "st6",
    d: "M314.4,231v-10.1c0,0-0.5-7.9-8.8-7.9h-12.8v18h-13.2v-52h32c0,0,16.7-2,16.7,15.2 c0,9-7.4,12.1-7.4,12.1s6.3,3,6.3,11.8V231H314.4 M292.8,200.7h13.6c4,0,7.2-2.2,7.2-4.9s-3.3-4.9-7.2-4.9h-13.6V200.7 L292.8,200.7"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 101.2002,
    cy: 273.969,
    r: 512.0732,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    className: "st7",
    d: "M226.4,230.9h-11.5l-14-15.4l-14.1,15.4h-8h-41.1v-52.1h41.1h7l15.1,16.5l15.2-16.5h10.1 v-0.1h32c0,0,16.7-1.9,16.7,15.3c0,15.3-5.5,20.1-22.6,20.1h-12.9v16.7L226.4,230.9 M209.9,205.3l16.4,18.1v-36.2L209.9,205.3 L209.9,205.3 M151,219.7h27.8l13-14.3l-13-14.3H151v8h27.1v11.8H151V219.7L151,219.7 M239.5,200.6h13.6c4,0,7.2-2.2,7.2-4.9 s-3.3-4.9-7.2-4.9h-13.6L239.5,200.6L239.5,200.6"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 101.2031,
    cy: 273.989,
    r: 512.0401,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_22_",
    className: "st8",
    d: "M404.4,230.8h-23.5v-12h20.6c0,0,7.4,0.9,7.4-4.1c0-4.7-11.2-4.3-11.2-4.3 s-18.2,1.6-18.2-15.5c0-17,16.4-16,16.4-16h25.3V191h-20.4c0,0-7-1.4-7,3.7c0,4.3,9.6,3.7,9.6,3.7s20.2-1.5,20.2,14.2 c0,16.8-13,18.3-17.6,18.3C405,230.9,404.4,230.8,404.4,230.8"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 101.1929,
    cy: 273.9802,
    r: 512.0659,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_25_",
    className: "st9",
    points: "333.8,230.9 333.8,179 375,179 375,191 347.1,191 347.1,199 374.3,199  374.3,210.8 347.1,210.8 347.1,219.7 375,219.7 375,230.9 333.8,230.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 101.2041,
    cy: 273.989,
    r: 512.0272,
    gradientTransform: "matrix(1 0 0 1 0 -282.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    style: {
      stopColor: "#008DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#006C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005F80"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_28_",
    className: "st10",
    d: "M451,230.8h-23.5v-12H448c0,0,7.5,0.9,7.5-4.1c0-4.7-11.2-4.3-11.2-4.3 s-18.2,1.6-18.2-15.5c0-17,16.4-16,16.4-16h25.3V191h-20.3c0,0-7-1.4-7,3.7c0,4.3,9.6,3.7,9.6,3.7s20.1-1.5,20.1,14.2 c0,16.8-13,18.3-17.6,18.3C451.6,230.9,451,230.8,451,230.8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.a5806635cd5314be006ddd1f45eea21b.svg";
export { ForwardRef as ReactComponent };